// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__Sqvxb","text":"PageHeader_text__hkuVY","title":"PageHeader_title__LPrWS","subtitle":"PageHeader_subtitle__RGkve","actions":"PageHeader_actions__RVKmF"};